var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WideTemplate',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Ehitussektori kandidaadid")]},proxy:true}])},[_c('PublicCurriculums',{attrs:{"store-state":_vm.$store.state.curriculum,"store-accessor":"curriculum/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }